import React, { Component } from 'react';

import Aux from '../hoc/Auxiliary';
import SocialMediaField from '../../components/UI/SocialMediaField/SocialMediaField';
import classes from './Footer.css';
import InfoField from '../../components/UI/HowItWorks/TrdHowItWorks/InfoField/InfoField';
import TrdHowItWorks from '../../components/UI/HowItWorks/TrdHowItWorks/TrdHowItWorks';

class Footer extends Component {

    state = { 
        showInfoDrawer: false
    }

    infoDrawerOpenHandler = () => {
        this.setState({ showInfoDrawer: true })
    }

    infoDrawerCloseHandler = () => {
        this.setState({ showInfoDrawer: false })
    }


    render() {
        return (
            <Aux>
            <div className={classes.SocialMedia}>
                <SocialMediaField />
                <InfoField clicked={this.infoDrawerOpenHandler}/>
                <TrdHowItWorks
                            open={this.state.showInfoDrawer}
                            closed={this.infoDrawerCloseHandler}/>
            </div>
            
            <div className={classes.Footer}>
    
                <p className={classes.FooterTag}>Copyright ©2020 Dibs-it.com</p>
                
            </div>
        </Aux>
        )
    }
 
}

 export default Footer;


// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js